
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import api from '../../../api'
import { ModalLayout } from '@appbase/templates'
import TemplateModalContent from './TemplateModalContent.vue'

/**
 * 템플릿 추가/편집 모달
 * 템플릿의 상세 설정을 수정할 수 있다.
 */
@Component({
    components: { ModalLayout, TemplateModalContent },
})
export default class TemplateModal extends Vue {
    @Prop({ type: Object, required: true }) template!: webpartv3.WebpartTemplate
    /** 관리자 페이지에서 설정한 회사 코드 */
    @Prop({ type: String, required: true }) company!: string
    /** 템플릿 생성을 위한 모달인지 편집을 위한 모달인지 여부 */
    @Prop({ type: String, default: 'new' }) mode!: 'edit' | 'new'
    /** 템플릿 모달 타이틀 */
    @Prop({ type: String }) title!: string;

    loading: boolean = false
    modalSize: string = 'max-width: 600px;'
    /** 메뉴에서 구성한 웹파트 페이지 목록 */
    pages: webpartv3.WebpartPage[] = []

    async created() {
        this.loading = true
        this.pages = await api.page.get(this.company)
        this.loading = false
    }

    /**
     * 저장 버튼 클릭 처리
     */
    handleSave() {
        // 템플릿 변경사항을 저장하기 전에 유효성을 검사한다.
        // 템플릿 명, 식별자 필수값
        if(this.template.name =="" || this.template.displayName==""){
            (window as any).alertAsync(this.$t("누락된_값이_있습니다").toString())
            return
        }
        // 저장 이벤트 발생
        this.$emit('save', this, this.template)
    }
}
